import { ModalCloseButton } from '../../../../Modal'

function ViewingPreviewModalCloseButton({ onClosePreview }) {
  return <ModalCloseButton onClose={onClosePreview} />
}

export default ViewingPreviewModalCloseButton
